module.exports = __webpack_public_path__ + "static/media/South-India.8e5bca89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/South-India.jpg
// module id = 999
// module chunks = 0